import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import PostsReducer from './reducers/PostsReducer';
import thunk from 'redux-thunk';
import { AuthReducer } from './reducers/AuthReducer';
import todoReducers from './reducers/Reducers';
import DepositorsReducer from './reducers/DepositorsReducer';
import DepositsReducer from './reducers/DepositsReducer';
import DepositInterestReducer from './reducers/DepositInterestReducer';
import CompaniesReducer from './reducers/CompaniesReducer';
import { KycMasterReducer } from './reducers/KycMasterReducer';
import CompanyKycReducer from './reducers/CompanyKycReducer';
import BranchesReducer from './reducers/BranchesReducer';
import UsersReducer from './reducers/UsersReducer';
import DashboardReducer from './reducers/DashboardReducer';
//import { reducer as reduxFormReducer } from 'redux-form';
const middleware = applyMiddleware(thunk);

const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducers = combineReducers({
    posts: PostsReducer,
    auth: AuthReducer,
    todoReducers,
    depositors: DepositorsReducer,
    deposits: DepositsReducer,
    depositInterest: DepositInterestReducer,
    companies: CompaniesReducer,
    kycMaster: KycMasterReducer,
    companyKyc: CompanyKycReducer,
    branches: BranchesReducer,
    users: UsersReducer,
    dashboard: DashboardReducer,
    //form: reduxFormReducer,
});

export const store = createStore(reducers, composeEnhancers(middleware));
